// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"a31a84f5","648":"38fcc79e","720":"7284ffc4","742":"7e64da75","787":"5e345c98","927":"27f54215","954":"a7648a59"}[chunkId] + ".chunk.js";
};